var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.icon)?_c('div',{staticClass:"nav-icon"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"nav-title headline-font"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }